import { Box, Typography, Card, Button, Stack, Grid } from "@mui/joy";
import Carousel from '../components/Carousel';
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useTheme, useMediaQuery } from '@mui/material';
import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionGroup from '@mui/joy/AccordionGroup';
import AccordionSummary from '@mui/joy/AccordionSummary';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import { accordionClasses } from '@mui/joy';
import { useEffect } from "react";



function Main() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'NASCAR — Главная';
  }, []);

  return (
    <Box sx={{ px: 2.5, mt: 4, overflowY: 'auto' }} >
      <Carousel width="auto" autoplayInterval={4000} images={[
        { image: './img/banner1.png' },
        { image: './img/banner2.png' },
        { image: './img/banner3.png' },
        { image: './img/banner4.png' },
        { image: './img/banner5.png' }
      ]}/>
      <Stack spacing={2} sx={{ px: 2.5, mt: 0 }}>
        <Typography level={isMobile ? "title-lg" : "h1"} sx={{ pt: '50px' }}>
          Модельный ряд. <Typography sx={{ color: '#828282', fontWeight: '500' }}>Какой электросамокат подойдет вам?</Typography>
        </Typography>

        <Card variant="outlined" sx={{ width: '100%', borderRadius: 20, backgroundColor: '#ffffff', position: 'relative', overflow: 'hidden', py: 16, border: '1px solid', borderColor: 'divider' }}>

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            <Box sx={{ margin: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px', objectFit: 'cover', zIndex: 1 }}>
              <Stack sx={{ textAlign: "center", mb: 1 }}>
                <Typography level={isMobile ? "title-lg" : "h2"}>
                  Электросамокаты
                </Typography>
                <Typography level={isMobile ? "body-sm" : "body-lg"}> Скорость, стиль и экологичность в каждой поездке! </Typography>
              </Stack>
              <Button onClick={() => navigate("/catalog")} sx={{
                border: '1px solid #333', color: '#333', borderRadius: 250, background: 'none', transition: '0.3s',
                '&:hover': {
                  background: 'red',
                  color: 'black',
                  borderColor: 'red',
                },
                '&:active': {
                  background: 'red',
                  color: 'black',
                  borderColor: 'red',
                },
              }}>
                Перейти в каталог
              </Button>
            </Box>


          </Box>
          {/*<img src="./img/productsImages/lemonV5/2.jpg" style={{ width: '100%', height: '100%', resize: 'horizontal', position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, opacity: 0.4, pointerEvents: 'none', objectFit: 'cover', zIndex: 0 }} />*/}
        </Card>

        <Typography level={isMobile ? "title-lg" : "h2"} sx={{ pt: '20px' }}>
          Почему стоит выбрать нас?
        </Typography>


        <Box sx={{ height: isMobile ? '250px' : '500px', position: 'relative' }}>
          <Card variant="outlined" sx={{ borderRadius: 20, height: '100%', overflow: 'hidden', p: 0 }}>


            <Box sx={{
              height: '100%',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: 'space-around',
              alignItems: 'center',
              zIndex: 2 // Над видео
            }}>
              <Box sx={{ maxWidth: isMobile ? '90%' : '40%', textAlign: isMobile ? 'center' : 'left', display: 'flex', flexDirection: 'column', gap: 2 }}>
                {!isMobile && (
                  <Typography level={isMobile ? "title-md" : "h3"} sx={{ color: 'black' }}>
                    Найдите свой идеальный электросамокат!
                  </Typography>
                )}
                <Typography level={isMobile ? "title-md" : "h6"} sx={{ color: 'black' }}>
                  Широкий выбор моделей, {isMobile && <br/>}гарантия качества и профессиональная консультация.
                </Typography>
              </Box>


              <Button
                onClick={() => navigate("/catalog")}
                variant="text"
                startDecorator={
                  <ShoppingCartIcon sx={{ height: isMobile ? "18px" : '25px', width: isMobile ? "18px" : '25px' }} />
                }
                sx={{
                  borderRadius: '250px',
                  zIndex: 2, // Над видео
                  color: 'black',
                  fontSize: isMobile ? "18px" : '25px',
                  transition: "color 0.3s ease",
                  '&:hover': {
                    color: 'red',
                    '.icon polygon': {
                      stroke: 'red',
                    },
                    '.icon circle': {
                      stroke: 'red',
                    },
                  },
                }}
              >
                Перейти
              </Button>
            </Box>
          </Card>
        </Box>

        <Typography level={isMobile ? "title-lg" : "h2"} sx={{ pt: '20px' }}>
          Как заказать электросамокат?
        </Typography>

        <Box>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 16 }}
            sx={{ flexGrow: 1 }}
          >
            <Grid xs={4}>
              <Card
                variant="plain"
                sx={{
                  borderRadius: 20,
                  bgcolor: '#ffffff',
                  height: '100%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  position: 'relative',
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <PersonIcon sx={{ width: 24, height: 24 }} />
                  <Typography level="title-lg">
                    Консультация
                  </Typography>
                </Box>
                <Typography level="body-md" sx={{ color: 'neutral.500' }}>
                  Подберем идеальный самокат.
                </Typography>
              </Card>
            </Grid>

            <Grid xs={4}>
              <Card
                variant="plain"
                sx={{
                  borderRadius: 20,
                  bgcolor: '#ffffff',
                  height: '100%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  position: 'relative',
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <PaymentIcon sx={{ width: 24, height: 24 }} />
                  <Typography level="title-lg">
                    Оплата
                  </Typography>
                </Box>
                <Typography level="body-md" sx={{ color: 'neutral.500' }}>
                  Удобные способы оплаты.
                </Typography>
              </Card>
            </Grid>

            <Grid xs={4}>
              <Card
                variant="plain"
                sx={{
                  borderRadius: 20,
                  bgcolor: '#ffffff',
                  height: '100%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  position: 'relative',
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <BuildIcon sx={{ width: 24, height: 24 }} />
                  <Typography level="title-lg">
                    Проверка
                  </Typography>
                </Box>
                <Typography level="body-md" sx={{ color: 'neutral.500' }}>
                  Тщательная проверка качества.
                </Typography>
              </Card>
            </Grid>

            <Grid xs={4}>
              <Card
                variant="plain"
                sx={{
                  borderRadius: 20,
                  bgcolor: '#ffffff',
                  height: '100%',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  position: 'relative',
                  border: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <SettingsIcon sx={{ width: 24, height: 24 }} />
                  <Typography level="title-lg">
                    Доставка
                  </Typography>
                </Box>
                <Typography level="body-md" sx={{ color: 'neutral.500' }}>
                  Быстрая доставка до двери.
                </Typography>
              </Card>
            </Grid>
          </Grid>

        </Box>


        <Box>
          <Typography level={isMobile ? "title-lg" : "h2"} sx={{ pt: '20px' }}>
            Остались вопросы?
          </Typography>
          <Typography level={isMobile ? "title-md" : "h3"} sx={{ color: 'neutral.500', mb: 2 }}>
            Мы подготовили ответы.
          </Typography>
          <Card variant="soft" sx={{ bgcolor: '#ffffff', borderRadius: 20, mb: 2, border: '1px solid', borderColor: 'divider' }}>
            <AccordionGroup
              sx={{
                maxWidth: '100%',
                [`& .${accordionClasses.root}`]: {
                  mb: 1.5,
                  '&:first-of-type': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                  },
                  '&:last-of-type': {
                    borderBottomLeftRadius: '12px',
                    borderBottomRightRadius: '12px',
                  },
                },
              }}
            >
              <Accordion>
                <AccordionSummary>Как узнать, какой электросамокат мне подойдет?</AccordionSummary>
                <AccordionDetails>
                  Наши консультанты помогут вам выбрать электросамокат, идеально подходящий под ваши потребности и стиль жизни. Мы учтем ваш вес, рост, предполагаемые маршруты, а также предпочтения по скорости и дальности поездок. Свяжитесь с нами для получения персональной консультации!
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary>Какой электросамокат выбрать для поездок по городу?</AccordionSummary>
                <AccordionDetails>
                  Мы поможем подобрать оптимальную модель для комфортных и быстрых перемещений по городским улицам. Предложим варианты с хорошей маневренностью, легким весом и достаточной дальностью хода для ваших ежедневных поездок на работу или учебу.
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary>Какая гарантия на электросамокаты?</AccordionSummary>
                <AccordionDetails>
                  Мы предоставляем гарантию на все наши электросамокаты и обеспечиваем качественное сервисное обслуживание. Гарантия распространяется на все основные компоненты, включая двигатель, аккумулятор и электронику. В случае неисправности, мы оперативно устраним проблему или заменим устройство.
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary>Могу ли я выбрать цвет и дизайн электросамоката?</AccordionSummary>
                <AccordionDetails>
                  Да, у нас представлен широкий выбор цветов и дизайнов, чтобы вы могли выбрать электросамокат по своему вкусу. В наличии модели различных стилей – от классических до современных, а также возможность заказать индивидуальную покраску или нанесение логотипа.
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary>Как выбрать электросамокат с подходящей дальностью хода?</AccordionSummary>
                <AccordionDetails>
                  Наши эксперты помогут подобрать модель с оптимальной дальностью хода, исходя из ваших ежедневных маршрутов. Мы учтем расстояние, которое вы планируете проезжать на одном заряде, и предложим варианты с подходящей емкостью аккумулятора. Также расскажем о способах увеличения дальности поездок.
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary>Какой электросамокат подойдет для бездорожья или пересеченной местности?</AccordionSummary>
                <AccordionDetails>
                  Мы поможем выбрать электросамокат с усиленной подвеской и мощным двигателем для комфортных поездок вне города. Предложим модели с большими колесами, амортизаторами и надежной конструкцией, способные справиться с неровностями и ухабами на грунтовых дорогах.
                </AccordionDetails>
              </Accordion>
            </AccordionGroup>
          </Card>
        </Box>

      </Stack>
    </Box>
  );
}

export default Main;
